import React from 'react';
import { Heading, Paragraph } from '@wunder/ui-components';
import { Trans } from '@lingui/react/macro';
import CompanyInfoFormFields from './CompanyInfoFormFields';

const CompanyInfoStep = () => {
  return (
    <>
      <Heading size={4} marginBottom={16}>
        <Trans id="businessAccount.create.companyInfo">Company info</Trans>
      </Heading>
      <Paragraph weight="light" marginBottom={32}>
        <Trans id="businessAccount.create.companyInfoDescription">
          Please provide the official details of your company as registered. This information is
          vital for verification purposes and for the correct addressing of any communications or
          agreements.
        </Trans>
      </Paragraph>

      <CompanyInfoFormFields />
    </>
  );
};

export default CompanyInfoStep;
